import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';
import '~/assets/css/fonts.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    line-height: 1.5;
    font-family: ${({ theme }) => theme.primaryFont};
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    -webkit-font-smoothing: antialiased;
    color: #25282a;
  }

  body, input, button {
    font: 14px 'Core Sans', sans-serif;
  }

  a {
    text-decoration: none;
    transition: all ease-out 0.1s;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }
  
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }
  
  .Toastify__toast { 
    padding-left: 22px !important; letter-spacing: 0.7px; 
    
    div{
      font-family: ${({ theme }) => theme.primaryFontLight};
      font-size: ${({ theme }) => theme.paragraph}px;
    }
  }
  
  .Toastify__toast--success { 
  background-color: ${({ theme }) => theme.success} !important 
  }
  
  .Toastify__toast--error { 
  background-color: ${({ theme }) => theme.danger} !important 
  }
`;
